import { schema } from 'normalizr'

const UserSchema = new schema.Entity('users')

export default UserSchema
